import { Container } from "@mui/material";
import React from "react";
import { useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import {
  useFindJobByCategoryApiQuery,
  useFindJobByZipCodeApiQuery,
} from "../../../services/apiSlice";
import Loading from "../../Loading";
import { GetJobSearchResult } from "./GetJobSearchResult";

const SearchResultCat = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  let searcCat = searchParams.get("categories");
  console.log({ searcCat });
  const {
    data: cateData,
    error,
    isError,
    isSuccess,
    isFetching,
  } = useFindJobByCategoryApiQuery(searcCat);
  console.log({ cateData });
  let AllResult;
  if (isFetching) {
    AllResult = <Loading />;
  } else if (isSuccess) {
    AllResult = cateData?.getAvailableJob;
  } else if (isError) {
    AllResult = Swal.fire({
      icon: "error",
      title: "Oops...",
      text: error?.cateData?.message,
    });
  }
  return (
    <Container className="md:ml-30" maxWidth="lg">
      <div className="flex  ml-10 justify-center  flex-col w-full py-20 ">
        {cateData?.getAvailableJob?.length > 0 ? (
          <GetJobSearchResult AllResult={AllResult} />
        ) : (
          <p className="py-4 text-center font-bold text-xs sm:text-base md:text-xl mx-3">
            No result found available
          </p>
        )}
      </div>
    </Container>
  );
};

export default SearchResultCat;
